import { useEffect, useRef, useState } from "react";
import { subscribeToast } from "util/appToast";

/**
 * 전역 하단 토스트 호스트 — App 루트에 1회 마운트.
 *  블랙 배경 + 흰 텍스트, 아래에서 올라왔다가(스프링 이징) 다시 내려가는 애니메이션.
 *  디자인 CSS 무수정(인라인 스타일만). 탭바 위(8.4rem)에 뜬다.
 */
export default function AppToastHost() {
  const [toast, setToast] = useState(null);   // 표시 텍스트(내려가는 동안 유지)
  const [visible, setVisible] = useState(false);
  const rafRef = useRef(0);

  useEffect(() => {
    const off = subscribeToast((t) => {
      if (t) {
        setToast(t);
        cancelAnimationFrame(rafRef.current);
        // 마운트 직후 프레임에 올라오는 트랜지션 시작
        rafRef.current = requestAnimationFrame(() =>
          requestAnimationFrame(() => setVisible(true)));
      } else {
        setVisible(false); // 아래로 내려감(텍스트는 유지)
      }
    });
    return () => { off(); cancelAnimationFrame(rafRef.current); };
  }, []);

  if (!toast) return null;
  return (
    <div
      key={toast.key}
      style={{
        position: "fixed",
        left: "50%",
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 8.4rem)",
        transform: `translateX(-50%) translateY(${visible ? "0" : "160%"})`,
        opacity: visible ? 1 : 0,
        transition: "transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.28s ease",
        background: "rgba(0, 0, 0, 0.85)",
        color: "#fff",
        padding: "1.2rem 2rem",
        borderRadius: "1.2rem",
        fontSize: "1.4rem",
        fontWeight: 500,
        whiteSpace: "nowrap",
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      {toast.message}
    </div>
  );
}
